module.exports = __webpack_public_path__ + "static/bigoffice-5db1505ecde4db31e1da41335f46e0e2.png";